
    <div [ngClass]="classes" class="badge">{{ text }}</div>
  